export default "__VITE_ASSET__BzIHjPAB__"